export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40548cc5c6581a4fca92f78174e996f7087401d815&name=revalidateCommunity!'